document.addEventListener("DOMContentLoaded", () => {
    document.body.addEventListener("click", (e) =>  handleModalClick(e));
    document.body.addEventListener("keydown", (e) => handleKeyDown(e));

    const handleModalClick = (e) => {
        const currentModalTrigger = e.target.closest("[data-tw-modal-src]");

        if (!currentModalTrigger) {
            return;
        }

        e.preventDefault();
        const modalID = currentModalTrigger.getAttribute("data-tw-modal-src").replace("#", "");
        showModal(modalID);

        const modalFormTrigger = currentModalTrigger.closest("[data-component='modal-form-trigger']");
        if (modalFormTrigger) {
            const modalForm = document.querySelector(`#${modalID}`);
            setInputValue(modalForm.querySelector("[name='requested_service']"), currentModalTrigger.getAttribute("data-requestedservice"));
            setInputValue(modalForm.querySelector("[name='requested_service_detail']"), currentModalTrigger.getAttribute("data-requestedservicedetail"));
            setElementContent(modalForm.querySelector("[data-component='modal-title']"), currentModalTrigger.getAttribute("data-title"));
            setElementContent(modalForm.querySelector("[data-component='modal-copy']"), currentModalTrigger.getAttribute("data-copy"));
        }

        return;
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const modalTrigger = e.target.closest("[data-tw-modal-src]");

            if (!modalTrigger) {
                return;
            }

            e.preventDefault();
            const modalID = modalTrigger.getAttribute("data-tw-modal-src");
            showModal(modalID);
            return;
        }
    };

    const showModal = (modalID) => {
        MicroModal.show(modalID, {
            disableScroll: true,
            openClass: 'tw-block',
            onShow: (modal) => {
                modal.classList.toggle("tw-hidden");
            },
            onClose: (modal) => {
                modal.classList.toggle("tw-hidden");
            }
        });
    };

    const setInputValue = (element, value) => {
        if (element) {
            element.value = value;
        }
    };

    const setElementContent = (element, value) => {
        if (element) {
            element.textContent = value;
        }
    };
});

